/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Api from '@/api';
import store from '@/store';
/* eslint-enable import/no-cycle */
import Util from '@/util';

const theState = {
    ssoId: '',
    inAction: false,
    login: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    contractors: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    masterdataCeleraone: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    masterdataSapMhn: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    masterdataSapNoz: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    masterdataEvalanche: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    masterdataSalesforce: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    info: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    entitlements: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    purchasesCeleraone: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    purchasesSapMhn: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    purchasesSapNoz: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    properties: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    optins: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    usergroups: {
        loading: false,
        lastCallSuccess: true,
        data: null,
    },
    linkedAccountsSummary: {
        loading: false,
        lastCallSuccess: true,
        data: {
            assigned: 0,
            unassigned: 0,
            ownages: [],
        },
    },
};

function sapPurchaseKeysHelper(state) {
    return {
        mhn: Object.keys(state.purchasesSapMhn.data || {}),
        noz: Object.keys(state.purchasesSapNoz.data || {}),
    };
}

const getters = {
    isLoading(state) {
        return Object.keys(state).some((key) => {
            if (typeof state[key] === 'object') {
                return state[key].loading;
            }
            return false;
        });
    },

    infoBoxes(state) {
        if (!state.info.loading && state.info.lastCallSuccess && state.info.data) {
            return [
                Util.timestampToInfoBox(state.info.data.registration_time, 'Registriert am'),
                Util.timestampToInfoBox(state.info.data.login_time, 'Letzter Login am'),

            ];
        }
        return [];
    },

    customerStates(state) {
        if (!state.info.loading && state.info.lastCallSuccess && state.info.data) {
            return [
                Util.infoToAccountStateInfoBox(state.info.data),
            ];
        }
        return [];
    },

    gpNummern(state) {
        if (!state.contractors.loading && state.contractors.lastCallSuccess && state.contractors.data) {
            return state.contractors.data.map(contractor => ({ id: contractor.id, scope: contractor.scope, original: contractor.original }));
        }
        return [];
    },

    hasGp(state) {
        return !state.contractors.loading && state.contractors.lastCallSuccess && !!state.contractors.data;
    },

    fullname(state) {
        if (state.masterdataCeleraone.data) {
            return Util.masterdataToFullName(state.masterdataCeleraone.data);
        }
        return '-';
    },

    email(state) {
        if (state.login.data && state.login.data.login) {
            return state.login.data.login;
        }
        return '-';
    },

    sapPurchasesAsArray(state) {
        const keys = sapPurchaseKeysHelper(state);
        const mhn = state.purchasesSapMhn.data ? keys.mhn.map(key => state.purchasesSapMhn.data[key]) : [];
        const noz = state.purchasesSapNoz.data ? keys.noz.map(key => state.purchasesSapNoz.data[key]) : [];
        return [
            ...mhn,
            ...noz,
        ];
    },

    sapPurchaseKeys(state) {
        const keys = sapPurchaseKeysHelper(state);
        return [
            ...keys.mhn.map(key => `${key} (MHN)`),
            ...keys.noz.map(key => `${key} (NOZ)`),
        ];
    },

    entitlements(state) {
        const e = state.entitlements.data || [];
        /* eslint-disable camelcase */
        return e.map(({ entitlement_id, store_id }) => ({
            entitlement_id,
            store_id,
            class: '',
        }));
        /* eslint-enable camelcase */
    },

    purchases(state) {
        let p = [];
        const now = (new Date()).getTime();
        if (store.getters.isAdminOrHigher) {
            p = state.purchasesCeleraone.data || [];
        } else {
            /* eslint-disable camelcase */
            p = (state.purchasesCeleraone.data || []).filter(({
                valid_from,
                valid_to,
            }) => {
                if (valid_from < now && valid_to < now) {
                    return false;
                }
                return true;
            });
        }
        /* eslint-disable camelcase */
        return p.map(({
            product_id,
            purchase_id,
            valid_from,
            valid_to,
        }) => {
            let style = '';
            if (valid_from < now && valid_to < now) {
                style = 'grey-row';
            } else if (valid_from < now && valid_to > now) {
                style = 'green-row';
            }
            return {
                product_id,
                purchase_id,
                ab: valid_from,
                bis: valid_to,
                class: style,
            };
        });
        /* eslint-enable camelcase */
    },

    userproperties(state) {
        const p = state.properties.data || [];
        /* eslint-disable-next-line */
        return p.map(({ store_id, name, value }) => ({
            store_id,
            name,
            value,
            class: '',
        }));
    },

    optins(state) {
        const oi = state.optins.data || [];
        /* eslint-disable camelcase */
        return oi.map(({ type, optin_id, valid_from }) => ({
            type,
            optin_id,
            valid_from,
            class: '',
        }));
    },
    usergroupKeys(state) {
        return Object.keys(state.usergroups.data || {});
    },

    usergroupsAsArray(state) {
        const keys = Object.keys(state.usergroups.data || {});
        return keys.map(key => state.usergroups.data[key]);
    },
};

const mutations = {
    setInAction(state, inAction) {
        state.inAction = inAction;
    },

    setSsoId(state, ssoId) {
        state.ssoId = ssoId;
    },

    setLoading(state, { key, loading }) {
        Vue.set(state[key], 'loading', loading);
    },

    setLastCallSuccess(state, { key, lastCallSuccess }) {
        Vue.set(state[key], 'lastCallSuccess', lastCallSuccess);
    },

    setData(state, { key, data }) {
        Vue.set(state[key], 'data', data);
    },
};

function actionHelper(theKey, commit, state) {
    const key = theKey;
    commit('setLoading', { key, loading: true });
    commit('setData', { key, data: null });
    Api.customer.detail[key](state.ssoId)
        .then(({ data }) => {
            commit('setLastCallSuccess', { key, lastCallSuccess: true });
            commit('setData', { key, data: data.data });
        })
        .catch(() => {
            commit('setLastCallSuccess', { key, lastCallSuccess: false });
            commit('setData', { key, data: null });
        })
        .finally(() => {
            commit('setLoading', { key, loading: false });
        });
}

const actions = {
    initState({ commit, dispatch }, ssoId) {
        commit('setSsoId', ssoId);
        dispatch('loadData');
    },

    loadData({ dispatch }) {
        dispatch('getLogin');
        dispatch('getContractors');
        dispatch('getMasterdataCeleraone');
        dispatch('getMasterdataSapMhn');
        dispatch('getMasterdataSapNoz');
        dispatch('getMasterdataEvalanche');
        dispatch('getMasterdataSalesforce');
        dispatch('getInfo');
        dispatch('getEntitlements');
        dispatch('getPurchasesCeleraone');
        dispatch('getPurchasesSapMhn');
        dispatch('getPurchasesSapNoz');
        dispatch('getProperties');
        dispatch('getOptins');
        dispatch('getUsergroups');
        dispatch('getLinkedAccountsSummary');
    },

    getLogin({ commit, state }) {
        actionHelper('login', commit, state);
    },

    getContractors({ commit, state }) {
        actionHelper('contractors', commit, state);
    },

    getMasterdataCeleraone({ commit, state }) {
        actionHelper('masterdataCeleraone', commit, state);
    },

    getMasterdataSapMhn({ commit, state }) {
        actionHelper('masterdataSapMhn', commit, state);
    },

    getMasterdataSapNoz({ commit, state }) {
        actionHelper('masterdataSapNoz', commit, state);
    },

    getMasterdataEvalanche({ commit, state }) {
        actionHelper('masterdataEvalanche', commit, state);
    },

    getMasterdataSalesforce({ commit, state }) {
        actionHelper('masterdataSalesforce', commit, state);
    },

    getInfo({ commit, state }) {
        actionHelper('info', commit, state);
    },

    getEntitlements({ commit, state }) {
        actionHelper('entitlements', commit, state);
    },

    getPurchasesCeleraone({ commit, state }) {
        actionHelper('purchasesCeleraone', commit, state);
    },

    getPurchasesSapMhn({ commit, state }) {
        actionHelper('purchasesSapMhn', commit, state);
    },

    getPurchasesSapNoz({ commit, state }) {
        actionHelper('purchasesSapNoz', commit, state);
    },

    getProperties({ commit, state }) {
        actionHelper('properties', commit, state);
    },

    getOptins({ commit, state }) {
        actionHelper('optins', commit, state);
    },

    getUsergroups({ commit, state }) {
        actionHelper('usergroups', commit, state);
    },

    getLinkedAccountsSummary({ commit, state }) {
        actionHelper('linkedAccountsSummary', commit, state);
    },


};


export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
